// utils/dummyData.js

export const options = ["1~2개", "3~4개", "5개 이상", "상담필요"];
export const options2 = ["1~2개", "3~4개", "5개 이상", "전체"];
export const options3 = ["30대", "40대", "50대 이상"];

export const dentalOptions = ["일반치료", "치아교정", "임플란트"];

export const phoneFirstOptions = ["010", "011", "016", "017", "018", "019"];

export const prohibitedWords = [
  "시발",
  "ㅅㅂ",
  "씨발",
  "씨빨",
  "씨이발",
  "씨이빨",
  "좆",
  "ㅈㄹ",
  "좇",
  "졷",
  "병신",
  "ㅂㅅ",
  "븅신",
  "빙신",
  "병1신",
  "병2신",
  "새끼",
  "ㅅㄲ",
  "새1끼",
  "새2끼",
  "색히",
  "느금마",
  "니엄마",
  "니애미",
  "느개비",
  "쪽바리",
  "짱깨",
  "짱개",
  "찌질",
  "찐따",
  "존나",
  "ㅈㄴ",
  "존1나",
  "존2나",
  "야동",
  "ㅈㄷ",
  "야사",
  "보지",
  "ㅂㅈ",
  "자지",
  "ㅈㅈ",
  "똥꼬",
  "섹스",
  "SEX",
  "쎅스",
  "쎄스",
  "SIBAL",
  "TMD",
  "ㄷㅁㅈ",
  "후장",
  "애자",
  "장애",
  "정신병자",
  "고아",
  "ㅈㄹ",
  "가슴",
  "유두",
  "젖",
  "젖꼭지",
  "ㄷㄷ",
  "유방",
  "유방암",
  "쌍놈",
  "ㅆㄴ",
  "썅",
  "썅년",
  "걸레",
  "창녀",
  "ㄱㄹ",
  "ㅊㄴ",
  "개새끼",
  "개소리",
  "개같",
  "개1같",
  "개2같",
  "모지리",
  "바보",
  "멍청",
  "미친놈",
  "미친년",
  "또라이",
  "ㄸㄹㅇ",
  "샹",
  "ㅅㅐㄲㅣ",
  "ㅂㅕㅇㅅㅣㄴ",
  "ㅈㄱ",
  "ㅇㅁㅎ",
  "시팔",
  "ㅆㅃ",
  "니미",
  "니미랄",
  "니미럴",
  "ㄴㅁ",
  "ㄴㅁㄹ",
  "니1미",
  "니2미",
  "니미씨",
  "니미씹",
  "씨미",
  "시미",
  "씹미",
  "ㅅㅁ",
  "씨바",
  "씨빨",
  "ㅆㅂㄹ",
  "니미1럴",
  "니미2럴",
  "니미시",
  "니미쉐",
  "니미쒸",
  "니미새",
  "니미썅",
  "니미쌍",
  "씨미럴",
  "ㅆㅁㄹ",
  "씨미랄",
  "시미랄",
  "씹미랄",
  "씹미럴",
  "니미치",
  "니미뭐",
  "니미크",
  "니미같",
  "느미랄",
  "느미럴",
  "느미",
  "씨랄",
  "시랄",
  "씹랄",
  "ㅆㄹ",
  "씨1랄",
  "씨2랄",
  "니미리",
  "니미나",
  "니미다",
  "니미것",
  "니미나발",
  "니미더러",
  "니미꼴",
  "니미봐",
  "니미했",
  "니미냐",
  "니미야",
  "니미해",
  "씨니미",
  "시니미",
  "씹니미",
  "ㅆ니미",
  "니밣",
  "니빢",
  "니발",
  "니빨",
  "니발놈",
  "니빨놈",
  "ㅅㅂㄹㅁ",
  "ㅆㅂㄹㅁ",
  "씨발럼",
  "씨발넘",
];
